module.exports = __webpack_public_path__ + "static/media/wax.4cba7932.svg";